import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

import { CoreModule } from '@abp/ng.core';
import { KENDO_TEXTBOX, TextBoxComponent,InputsModule } from '@progress/kendo-angular-inputs';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { SVGIcon, eyeIcon, eyeSlashIcon } from '@progress/kendo-svg-icons';

@Component({
  selector: 'nexweb-password-input',
  standalone: true,
  templateUrl: './password-input.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordInputComponent),
      multi: true,
    },
  ],
  imports: [CoreModule, ReactiveFormsModule, CommonModule, InputsModule, KENDO_TEXTBOX, KENDO_BUTTON],
})
class PasswordInputComponent implements ControlValueAccessor, AfterViewInit {
  @Input() disabled: boolean;
  @Input() form: FormGroup;
  @Input() columnName: string;
  @Input() autocomplete: string;
  @Input() value: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Output() readonly blurEvent = new EventEmitter<any>();

  @ViewChild('textbox') public textbox: TextBoxComponent;

  public showPassword = false;
  public eyeIcon: SVGIcon = eyeIcon;
  public eyeSlashIcon: SVGIcon = eyeSlashIcon;

  public ngAfterViewInit(): void {
    this.textbox.input.nativeElement.type = 'password';
  }

  public toggleVisibility(): void {
    const inputEl = this.textbox.input.nativeElement;
    inputEl.type = inputEl.type === 'password' ? 'text' : 'password';
    this.showPassword = inputEl.type === 'text';
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public registerOnChange(fn: (password: string) => void): void {}

  public registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public onBlur(event: any) {
    this.blurEvent.emit(event);
  }

  public writeValue(password: string): void {
    if (this.form && this.columnName) {
      this.form.get(this.columnName)?.setValue(password ?? '', { emitEvent: false });
    }
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // @ts-expect-error: Never read
  private onTouched: () => void = () => {};
}

export default PasswordInputComponent;
